var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(!_vm.success)?_c('Loading'):(_vm.success == 'erro')?_c('Error'):[(_vm.$route.path.includes('painel-configuracoes'))?[_c('router-view')]:[_c('Navbar'),_c('router-view'),_c('Footer')]]],2)}
var staticRenderFns = []

export { render, staticRenderFns }